import legacy from "./legacy";
import lpa from "./lpa";

const PROFILES = { legacy, lpa };
const id = (process.env.REACT_APP_SEMINAR || "legacy").trim().toLowerCase();

export const SEMINAR = PROFILES[id] || legacy;
